/* @flow weak */

'use strict';

const React = require('react');
const Reflux = require('reflux');
const _ = require('lodash');

const AnswerActions = require('../../actions/AnswerActions.jsx');
const AnswerStore = require('../../stores/AnswerStore.jsx');
const ValidatorStore = require('../../stores/ValidatorStore.jsx');
const PaymentPlanStore = require('../../stores/PaymentPlanStore.jsx');
const ProductStore = require('../../stores/ProductStore.jsx');

const PriceSection = require('./PriceSection.jsx');
const PaymentPlanSection = require('./PaymentPlanSection.jsx');
const DialogRenderer = require('../renderers/DialogRenderer.jsx');

const Config = require('../../configs/Config.js');
const Loader = require('../../loaders');
const ln = Loader.ln || 'en_US';

const CallToActionSection = React.createClass({
  mixins: [
    Reflux.connect(ValidatorStore, 'validationData')
  ],

  getInitialState() {
    return { directingToCart: false }
  },

  showValidationDialog(invalidQuestions) {
    this.setState({ directingToCart: false },
      this.validationDialog.showDialog(null, invalidQuestions)
    );
  },

  showDisclaimerDialog() {
    if (!this.state.directingToCart) {
      this.disclaimerDialog.showDialog();
    }
  },

  submitAnswers() {
    if (!this.state.validationData.valid
      && (Config.productline.KSUNIVCollections == ProductStore.getProductLineId()
        || (Config.productline.ScholasticHighSchoolRings == ProductStore.getProductLineId() && Loader.schoolCode == '999999'))) {
      console.log('Skip saving and erroring until the configuration is valid!');
      return;
    }
    if (!this.state.directingToCart) {
      this.setState({ directingToCart: true }, AnswerActions.submit.bind(null, this.showValidationDialog, this.handleSubmitError));
    }
  },

  handleSubmitError() {
    this.setState({ directingToCart: false }, this.errorSubmittingDialog.showDialog());
  },

  checkFusion() {
    var curAnswers = AnswerStore.fetchAll();
      for (var id in curAnswers) {
        var q = curAnswers[id];
        if (q.part && q.part.name && q.part.name.toLowerCase().includes('fus')) {
          return true;
        }
      }

      return false;
  },

  isChecked (event) {
    var isActive = event.target.checked;
    AnswerStore.setFusionCheck(isActive);
    this.setState({ directingToCart: this.state.directingToCart });
  },

  render() {
    let disclaimerText = !Config.features.bypassCartConfirmation && _.get(this.props.productData.product, 'metadata.ImageDisclaimerText');
    let titleText = _.get(this.props.productData.product, 'metadata.NotFinishedDialogTitle') 
      || Config.features.notFinishedText[ln] || Config.features.notFinishedText['en_US'];
    let buttonText = _.get(this.props.productData.product, 'metadata.NotFinishedDialogButtonText') || 'OK';
    let productName = Loader.productName || ProductStore.getProductName();

    let disclaimerDialogButtons = [
      { text: 'Proceed to Check Out', btnClass: 'uc-primary-btn', action: this.submitAnswers },
      { text: 'Continue Designing' }
    ];

    let paymentPlanSection;
    if (PaymentPlanStore.getIsAvailable()) {
      paymentPlanSection = (<PaymentPlanSection />);
    }

    let addToCartButton;
    if (!Loader.readOnly && (Config.features.addToCartButtons === 'both' || this.props.section === Config.features.addToCartButtons)) {
      let className = `uc-cart-button uc-${this.props.section}`;

      if (Config.features.addToCartButtonExtraClass) {
        className += ' ' + Config.features.addToCartButtonExtraClass;
      }

      if (!this.state.validationData.valid || this.state.directingToCart || (this.checkFusion() && !AnswerStore.getFusionCheck())) {
        className += ' uc-disabled'
      }

      let fusionCheckboxClass = this.checkFusion() ? 'checkbox-container': 'checkbox-container hide-checkbox';
      let checkFus = AnswerStore.getFusionCheck();

      addToCartButton = (
        <div>
          <div className={fusionCheckboxClass}>
            <input
              className="checkbox-input"
              type="checkbox"
              id="fusion"
              name="fusion"
              onChange={(event) => this.isChecked(event)} />
            <label for="fusion"><strong>*</strong>I acknowledge that Fusion Coated Rings may delay significantly your estimated delivery</label>
          </div>
          <button
            className={className}
            disabled={this.checkFusion() && !AnswerStore.getFusionCheck()}
            onClick={disclaimerText && this.state.validationData.valid ? this.showDisclaimerDialog : this.submitAnswers}
            tabIndex={this.props.section === 'top' ? 1 : 999}>
            {Config.features.cartButtonText[ln]}
          </button>
        </div>
      );
    }

    return (
      <div className="uc-cta-section">
        <div className="uc-pricesection-product-name">
          {Config.features.ctaPrice ?
            <PriceSection />
            : null}

          {Config.features.ctaName ?
            <div className="uc-product-name">
              {productName}
              {Config.features.showProductId ?
                <div className="uc-product-id"><span>Item #:</span> {ProductStore.getProductId()}</div>
                : null}
            </div>
            : null}
        </div>

        {paymentPlanSection}

        {addToCartButton}

        <DialogRenderer
          ref={(c) => this.disclaimerDialog = c}
          title='<h1>Confirm Purchase</h1>'
          size='small'
          align='center'
          buttons={disclaimerDialogButtons}>
          {disclaimerText}
        </DialogRenderer>

        <DialogRenderer
          ref={(c) => this.validationDialog = c}
          title={'<h1>' + titleText + '</h1>'}
          buttons={[{ text: buttonText, btnClass: 'uc-primary-btn' }]}>
          {Config.features.questionHaveErrorsText[ln] || Config.features.questionHaveErrorsText['en_US']}:
        </DialogRenderer>

        <DialogRenderer
          ref={(c) => this.errorSubmittingDialog = c}
          title='<h1>Oops!</h1>'
          buttons={[{ text: 'OK', btnClass: 'uc-primary-btn' }]}>
          {Config.features.errorMessageText[ln] || Config.features.errorMessageText[en_US]}
        </DialogRenderer>
      </div>
    );
  }
});

module.exports = CallToActionSection;


// WEBPACK FOOTER //
// ./src/base/scripts/components/section/CallToActionSection.jsx